import { Formik, FormikHelpers } from 'formik'
import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from 'components/v2/Button'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import FormLayout from 'components/v2/FormLayout'
import { RuleCostCard } from 'features/PartnerCost/components/RuleCostCard'
import { INewPartnerCostFormValues } from 'features/PartnerCost/types'
import { schema } from './schema'
import { ALL_OPERATION_DAYS } from 'models/services'
import { BaseCostCard } from 'features/PartnerCost/components/BaseCostCard'
import { isEmpty } from 'lodash'

interface INewPartnerCostProps {
  onSubmit: (values: INewPartnerCostFormValues, helpers: FormikHelpers<INewPartnerCostFormValues>) => void
  loading?: boolean
  errors?: string[]
  isPerKm?: boolean
}

export const NewPartnerCost = ({ onSubmit, loading, errors, isPerKm = false }: INewPartnerCostProps): ReactElement => {
  const intl = useIntl()

  const initialValues: INewPartnerCostFormValues = {
    partner: null,
    partnerVehicles: [],
    routes: [],
    routeServices: [],
    startDate: new Date(),
    endDate: null,
    operationDays: ALL_OPERATION_DAYS,
    baseCosts: [],
    note: ''
  }

  return (
    <Formik initialValues={initialValues} validationSchema={schema(intl)} onSubmit={onSubmit}>
      {({ handleSubmit, dirty }): ReactElement => {
        return (
          <FormLayout.Content as="form" onSubmit={handleSubmit}>
            <RuleCostCard />
            <BaseCostCard isPerKm={isPerKm} />
            {!isEmpty(errors) && (
              <FormLayout.Actions>
                <div>
                  {errors?.map((error) => (
                    <ErrorMessage key={error}>{error}</ErrorMessage>
                  ))}
                </div>
              </FormLayout.Actions>
            )}
            <FormLayout.Actions>
              <Button type="submit" kind="primary" disabled={!dirty} loading={loading}>
                <FormattedMessage id="dictionary.save" defaultMessage="Save" />
              </Button>
            </FormLayout.Actions>
          </FormLayout.Content>
        )
      }}
    </Formik>
  )
}
